import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-search-highlight" }
const _hoisted_2 = { class: "search-highlight-container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "keyword" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "搜索", -1)
const _hoisted_6 = { class: "menu" }
const _hoisted_7 = { class: "current" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("上一个")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("下一个")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_search_highlight = _resolveComponent("search-highlight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_ElInput, {
            onKeydown: _withKeys(_ctx.checkKeydown, ["enter"]),
            class: "input",
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
            placeholder: "输入关键字搜索",
            size: "small"
          }, null, 8, ["onKeydown", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.matchCount ? _ctx.currentIdx : 0) + " / " + _toDisplayString(_ctx.matchCount), 1),
          _createVNode(_component_ElButton, {
            type: "primary",
            onClick: _withModifiers(_ctx.searchLast, ["stop"])
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ElButton, {
            type: "primary",
            onClick: _withModifiers(_ctx.searchNext, ["stop"])
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_search_highlight, {
        class: "content-container",
        ref: "search",
        onCurrentChange: _ctx.currentChange,
        onMatchCountChange: _ctx.matchCountChange,
        keyword: _ctx.keyword,
        content: _ctx.content
      }, null, 8, ["onCurrentChange", "onMatchCountChange", "keyword", "content"])
    ])
  ]))
}